function removeItemsWithAllLabel(navParentItems) {
    // Deep clone the input object to ensure immutability
    const navItemsCopy = JSON.parse(JSON.stringify(navParentItems));

    // Regex: matches 'all' or 'all ...' (case-insensitive, start of string)
    const stringMatchRegex = /^all( |$)/i;

    if (!navItemsCopy.items || !Array.isArray(navItemsCopy.items)) {
        return navItemsCopy;
    }

    navItemsCopy.items = navItemsCopy.items.filter(navItem => {
        if (!navItem || !Array.isArray(navItem.items) || !navItem.items?.length) {
            return true;
        }

        navItem.items = navItem.items.filter(childrenItem => {
            if (!childrenItem || !Array.isArray(childrenItem.items) || !childrenItem.items?.length) {
                return true;
            }

            childrenItem.items = childrenItem.items.filter(subChildrenItem => {
                if (!subChildrenItem.label || typeof subChildrenItem.label !== 'string') {
                    return true;
                }

                // Remove if label matches regex
                return !stringMatchRegex.test(subChildrenItem.label.trim());
            });

            return childrenItem.items?.length > 0;
        });

        return navItem.items?.length > 0;
    });

    return navItemsCopy;
}

export default {
    removeItemsWithAllLabel
};
